// Reusable plan button component for the plan selection dialog
import { CountryStripePriceInfo } from "@/src/features/pricing/types";
import { formatCurrency } from "@/src/utils/formatCurrency";

interface PlanButtonProps {
  price: CountryStripePriceInfo;
  planType: "yearly" | "monthly";
  isSelected: boolean;
  onSelect: () => void;
  savingsBadge?: string;
}

export const PlanButton = ({
  price,
  planType,
  isSelected,
  onSelect,
  savingsBadge,
}: PlanButtonProps) => {
  const displayName = planType === "yearly" ? "Yearly" : "Monthly";
  const billingPeriod = planType === "yearly" ? "year" : "mo";

  const displayPrice =
    planType === "yearly"
      ? formatCurrency(
          Math.round((price.unit_amount ?? 0) / 12),
          price.currency || "GBP"
        )
      : formatCurrency(price.unit_amount ?? 0, price.currency || "GBP");

  return (
    <div className="relative">
      {savingsBadge && (
        <div className="absolute left-1/2 top-px z-10 -translate-x-1/2 -translate-y-1/2 rounded-full bg-spring px-2 py-0 font-body text-xs font-semibold">
          {savingsBadge}
        </div>
      )}
      <button
        onClick={onSelect}
        className={`w-full rounded-xl border-2 p-4 text-left transition-colors hover:bg-zinc-50 ${
          isSelected
            ? "border-zinc-900 bg-zinc-100"
            : "border-zinc-300 bg-white"
        }`}
      >
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-body text-lg text-zinc-900">{displayName}</h3>
            <p className="font-body text-sm text-zinc-600">
              Billed as{" "}
              {formatCurrency(price.unit_amount ?? 0, price.currency || "GBP")}{" "}
              / {billingPeriod}
            </p>
          </div>
          <div className="text-right">
            <p className="font-body text-xl text-zinc-900">
              {displayPrice} / mo
            </p>
          </div>
        </div>
      </button>
    </div>
  );
};
